import { configureStore } from '@reduxjs/toolkit';

import { ServiceLocator } from '../services/serviceLocator';

import mediaReducer from './slices/mediaSlice';
import productReducer from './slices/productSlice';
import type { RootState } from './types';

export { type RootState };

export const store = configureStore({
  reducer: {
    product: productReducer,
    media: mediaReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
ServiceLocator.registerStore(store);
